export const STORAGE_ROOT_KEY = "REDTRACKER_STORAGE_ROOT_KEY";

export const DEFAULT_STORAGE_CONFIG = {
  version: 1,
  walletAddress: null,
};

export function getStorageConfig() {
  let storageConfigStr = localStorage.getItem(STORAGE_ROOT_KEY);
  if (storageConfigStr == null) {
    updateStorageConfig(DEFAULT_STORAGE_CONFIG);
    return DEFAULT_STORAGE_CONFIG;
  }
  return JSON.parse(storageConfigStr);
}

export function updateStorageConfig(storageConfig) {
  localStorage.setItem(STORAGE_ROOT_KEY, JSON.stringify(storageConfig));
}
